import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, mergeMap } from "rxjs/operators";
import { ArticleGenerique } from '../../../../delivery/shared/article-generique/article-generique';
import { ClientService } from "../../../../shared/client/client.service";
import { Change } from '../../../../shared/client/contrat/changes';
import { ContratService } from '../../../../shared/client/contrat/contrat.service';
import { Taille } from '../../../../shared/client/contrat/taille';
import { typeFamille } from '../../porteur-details/dotation/card-article/famille';
import { logos } from '../../porteur-details/dotation/card-article/logos';
import { PorteurService } from '../../shared/porteur.service';


@Component({
  selector: 'app-porteur-dotation-form',
  templateUrl: './porteur-dotation-form.component.html',
  styleUrls: ['./porteur-dotation-form.component.scss']
})
export class PorteurDotationFormComponent implements OnInit {

  @Input()
  control: FormGroup;

  @Output()
  onClose: EventEmitter<void> = new EventEmitter();

  articles: Array<ArticleGenerique> = new Array<ArticleGenerique>();
  tailles: Array<Taille> = new Array<Taille>();
  changes: Array<Change> = new Array<Change>();
  loadTaille: Subscription = new Subscription();
  loadChange: Subscription = new Subscription();

  csv: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  logo = logos;
  typeFamille = typeFamille;
  retouches = [
    "-3 cm",
    "-6 cm",
    "-9 cm",
    "-12 cm"
  ];

  selected_value = null;

  constructor(
    private contratService: ContratService,
    private porteurService: PorteurService,
    private clientService: ClientService,
  ) {

  }

  ngOnInit() {
    this.change.disable()
    this.clientService.getFirstCurrentClient().pipe(
      mergeMap(currentClient => {
        return this.contratService.getArticleVT(currentClient.code_service);
      })
    ).subscribe(articles => {
      this.articles = articles;
    });
    this.article.valueChanges.pipe(filter(article => article != null)).subscribe(article => {
      this.change.enable()
      this.computeCsv();
      this.clearTailles();
      this.clearChanges();
      this.loadChanges();
      this.loadTailles();
    });
    this.clientService.modifCodeService = this.clientService.currentClient$.getValue().code_service;
  }

  private computeCsv() {
    let pictoFamille = this.findTypeFamille();
    if (pictoFamille) {
      this.csv.next(logos[pictoFamille['type']]);
    }
  }

  private clearTailles() {
    this.tailles = new Array<Taille>();
    this.taille.setValue(undefined);
  }

  private clearChanges() {
    this.changes = new Array<Change>();
    this.change.setValue(undefined);
  }

  removeControl() {
    this.onClose.next();
  }

  private loadTailles() {
    this.loadTaille = this.contratService.getTailles(this.article.value).subscribe(tailles => {
      this.tailles = tailles;
    });
  }

  private loadChanges() {
    this.loadChange.unsubscribe();
    this.loadChange = this.contratService.getChanges(this.article.value).subscribe(changes => {
      this.changes = changes;
    });
  }


  private getCurrIndex(): number {
    return this.tailles.indexOf(this.taille.value);
  }

  inc() {
    let index = this.getCurrIndex();
    if (index !== null && this.tailles[index + 1] !== undefined) {
      this.taille.setValue(this.tailles[index + 1]);
    }

  }

  dec() {
    let index = this.getCurrIndex();
    if (index !== null && this.tailles[index - 1] !== undefined) {
      this.taille.setValue(this.tailles[index - 1]);
    }
  }

  get article(): AbstractControl {
    return this.control.get('article');
  }

  get taille(): AbstractControl {
    return this.control.get('taille');
  }

  get change(): AbstractControl {
    return this.control.get('change');
  }

  get qteSouhaite(): AbstractControl {
    return this.control.get('qteSouhaite');
  }

  get retouche(): AbstractControl {
    return this.control.get('retouche');
  }

  private findTypeFamille() {
    let cle_ref = this.article.value.famille.cle_ref.toString();
    let pictoFamille;
    let breakIt = false;
    for (let type of this.typeFamille) {
      for (let article of type['articles']) {
        if (cle_ref.match(article['famille']) || article['famille'] == cle_ref) {
          if (this.article.value.code_article.match(article['code'])) {
            pictoFamille = type;
            breakIt = true;
            break;
          }
        }
      }
      if (breakIt === true) {
        break;
      }
    }
    return pictoFamille;
  }

  facturationTypeSB() {
    if (this.change.value) {
      if (this.change.value.type_facturation.cle_ref == 'S' || this.change.value.type_facturation.cle_ref == 'B') {
        this.qteSouhaite.setValidators([Validators.required])
        this.qteSouhaite.updateValueAndValidity()
        return true;
      }
    }
    this.qteSouhaite.setValue(null)
    this.qteSouhaite.setValidators([])
    this.qteSouhaite.updateValueAndValidity()
    return false
  }
}
